import type { FilterOperationSchema } from '../../types.js';

type Keys =
    | 'inArray'
    | 'between'
    | 'equals'
    | 'before'
    | 'after'
    | 'tomorrow'
    | 'today'
    | 'yesterday'
    | 'nextWeek'
    | 'thisWeek'
    | 'lastWeek'
    | 'nextMonth'
    | 'thisMonth'
    | 'lastMonth'
    | 'nextQuarter'
    | 'thisQuarter'
    | 'lastQuarter'
    | 'nextYear'
    | 'thisYear'
    | 'lastYear'
    | 'yearToDate';

export const DATE_FILTER_OPERATION: FilterOperationSchema<Keys> = {
    inArray: {
        id: 'inArray',
        label: 'Filterliste',
    },
    // ---
    between: {
        id: 'between',
        label: 'Zwischen',
    },
    // ---
    equals: {
        id: 'equals',
        label: 'Gleich',
    },
    before: {
        id: 'before',
        label: 'Vor',
    },
    after: {
        id: 'after',
        label: 'Nach',
    },
    // ---
    tomorrow: {
        id: 'tomorrow',
        label: 'Morgen',
    },
    today: {
        id: 'today',
        label: 'Heute',
    },
    yesterday: {
        id: 'yesterday',
        label: 'Gestern',
    },
    // ---
    nextWeek: {
        id: 'nextWeek',
        label: 'Nächste Woche',
    },
    thisWeek: {
        id: 'thisWeek',
        label: 'Diese Woche',
    },
    lastWeek: {
        id: 'lastWeek',
        label: 'Letzte Woche',
    },
    // ---
    nextMonth: {
        id: 'nextMonth',
        label: 'Nächster Monat',
    },
    thisMonth: {
        id: 'thisMonth',
        label: 'Dieser Monat',
    },
    lastMonth: {
        id: 'lastMonth',
        label: 'Letzter Monat',
    },
    // ---
    nextQuarter: {
        id: 'nextQuarter',
        label: 'Nächstes Quartal',
    },
    thisQuarter: {
        id: 'thisQuarter',
        label: 'Dieses Quartal',
    },
    lastQuarter: {
        id: 'lastQuarter',
        label: 'Letztes Quartal',
    },
    // ---
    nextYear: {
        id: 'nextYear',
        label: 'Nächstes Jahr',
    },
    thisYear: {
        id: 'thisYear',
        label: 'Dieses Jahr',
    },
    lastYear: {
        id: 'lastYear',
        label: 'Letztes Jahr',
    },
    // ---
    yearToDate: {
        id: 'yearToDate',
        label: 'Jahr bis heute',
    },
} as const;

export type DateFilter = typeof DATE_FILTER_OPERATION;
export type DateFilterValues = DateFilter[keyof typeof DATE_FILTER_OPERATION];
export type DateFilterValuesWithoutInArray = Exclude<DateFilterValues, DateFilter['inArray']>;
